import { sendEvent } from '@utils/core/track';
import generatePath from '@utils/generatePath';
import { ONE_ON_ONE_ES, ONE_ON_ONE_EN} from 'constants/url';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.scss';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';


const MapCoversSection: FC = () => {
	const { width } = useResizeObserver()
	const { transData } = useTranslation('home.mapCovers')
	const local = useSelector((state: ConnectState) => state.app.local);
	
	const getLink = () => {
		return generatePath(local === 'es' ? ONE_ON_ONE_ES : ONE_ON_ONE_EN) + '#subject';
	};

	return (
		<section className={styles['ac-map']}>
			<div className={styles['ac-map-container']}>
				<div className={styles['contact-us']}>
					<div className={styles['list']}>
						<a href="" className={styles['logo']}><img src="https://web-data.zmlearn.com/image/6w2F8cBp1h59YeRtRbTqZc/logo.png"/></a>
						<div className={styles['info']}>
							<h1>AirClass华人</h1>
							<p><a href="http://airclasskids.com/" target='_bank'><i className={styles['link']}></i>kids.air-class.com</a></p>
						</div>
						<div className={styles['info']}>
							<h1>Apply to be a tutor</h1>
							<p><i className={styles['mail']}></i>tutor@air-class.com</p>
						</div>
					</div>
					<div className={styles['quick']}>
						<h1>Quick Links</h1>
						<p className={styles['info']}><a target="_blank" href="/en/main-home#school">About AirClass</a></p>
						<p><a target="_blank" href="/en/teams-careers">Teams and Careers</a></p>
						<p><a target="_blank" href="/en/join-us">Join us</a></p>
						<p><a target="_blank" href="/en/for-parents">For parents</a></p>
						<p><a target="_blank" href="/en/partner">Partner with us</a></p>
					</div>
					<div className={styles['contact']}>
						<h1>Contact us</h1>
						<p className={styles['info']}><i className={styles['mail']}></i>contact@air-class.com</p>
						<p><i className={styles['phone']}></i>+44 (0)2032397887</p>
						<p><i className={styles['service']}></i>service01@air-class.com</p>
						{/* <a href="https://www.kidsafeseal.com/certifiedproducts/airclass.html" target="_blank" className={styles['kids']}><img src="https://web-data.zmlearn.com/image/d7X4ASHeeR1PzmXfwGAL6B/kids-safe.png"/></a> */}
					</div>
				</div>
				<div className={styles['line']}></div>
				<div className={styles['copy-right']}>
					<div className={styles['icon']}>
						<a href="https://www.facebook.com/airclassglobal" className={styles['facebook']} target="_blank">
							<img className={styles['img']} src="https://web-data.zmlearn.com/image/74uWyujT87LnDgV1gdcGQX/facebook.png" alt="" />
						</a>
						<a href="https://www.instagram.com/airclass_global/" className={styles['instagram']} target="_blank">
							<img className={styles['img']} src="https://web-data.zmlearn.com/image/5NpUzKHjGmuaoSL5awYZtH/ins.png" alt="" />
						</a>
						<span className={styles['WeChat']}>   
							<img className={styles['img']} src="https://web-data.zmlearn.com/image/rGREhBGVN326ErZyuZYvCW/wechat.png" alt="" />
							<div className={styles['qrcode']}>
								<img src="https://web-data.zmlearn.com/image/ogqcjqzQmPWz51aMu2AK92/footer_qrcode.png" alt="" loading="lazy"/>
								<div className={styles['title']}>AirClass Kids</div>
								<div className={styles['text']}>WeChat official account</div>
							</div>
						</span>
						<a href="https://twitter.com/airclassglobal" target="_blank">
							<img className={styles['img']} src="https://web-data.zmlearn.com/image/5Xy3Xsi7ViDyBJA5bcv1er/twitter.png" alt="" />
						</a>
					</div>
					<p><span>COPYRIGHT 2021-AIRCLASS(SINGAPORE)PTE</span><span className={styles['text']}>LTD - ALL RIGHTS RESERVED</span></p>
				</div>
			</div>
		</section>
	);
}

export default MapCoversSection
